<mat-card (touchstart)="swipe($event, 'start')" (touchend)="swipe($event, 'end')" [ngClass]="class">
  <ng-content></ng-content>
</mat-card>